import { IMaverickApis } from "./IMaverickApis"
import { ICatalogueSearchReqParam, ICatalogueSearchResponse } from "../../interfaces/api/maverick/ICatalogueSearch"
import ApiUtils from "../ApiUtils"
import { CareCatalogues } from "../../components/patient/ongoingConsultation/history/helper"

const dietGuidelineCategory = "$dietGuidelineCategory"

// const fetchDishesByDishNameUrl: string = MAVERICK_API_PREFIX + "/dish/dish_catalogue?q=";
// const fetchDietGuidelinesByCategory: string = MAVERICK_API_PREFIX + "/care/guideline_catalogue?action=$dietGuidelineCategory&q=";
// const fetchMindfulnessActivitiesUrl: string = MAVERICK_API_PREFIX + "/mind/mind_tag_catalogue/?q=";
// const fetchCommonInterventionsUrl: string = MAVERICK_API_PREFIX + "/care/intervention_catalogue?";

const MaverickUrls = {
	catalogueSearch: (catalogueName: string) => `/care/${catalogueName}`,
	fitnessWorkoutSearch: (query: string) => `/fitness/workout_tag_catalogue?q=${query}`,
	meditationWorkoutSearch: (query: string) => `/mind/mind_tag_catalogue/?q=${query}`,
}

const MavericCatalogueNames = {
	allergy: "allergies_catalogue",
}

export default class MaverickApis implements IMaverickApis {
	getServiceUrl = (url: string) => "/maverick" + url
	// getDishByDishName(input: string): Promise<IDishCatalogueResponse[]> {
	// 	return ApiUtils.apiGetRequest(fetchDishesByDishNameUrl + encodeURIComponent(input));
	// }
	// getDietGuidelinesByCategory(input: string, category: string): Promise<IDishCatalogueResponse[]> {
	// 	return ApiUtils.apiGetRequest(fetchDietGuidelinesByCategory.replace(dietGuidelineCategory, category) + input);
	// }
	// getMindfulnessActivities(input: string): Promise<any[]> {
	// 	return ApiUtils.apiGetRequest(fetchMindfulnessActivitiesUrl + input);
	// }
	// getCommonInterventions(input: string, resultSize: number = 20): Promise<IInterventionCatalogueResponse[]> {
	// 	return ApiUtils.apiGetRequest(fetchCommonInterventionsUrl + `result-size=${resultSize}&q=${input}&utm_source=ORION`);
	// }
	searchAllergyCatalogue(params: ICatalogueSearchReqParam): Promise<ICatalogueSearchResponse[]> {
		return ApiUtils.get(this.getServiceUrl(`${MaverickUrls.catalogueSearch(CareCatalogues.ALLERGY)}?${ApiUtils.requestToQueryParams(params)}`))
	}
	searchCareCatalogue(payload: any, catalogue: CareCatalogues): Promise<ICatalogueSearchResponse[]> {
		return ApiUtils.post(this.getServiceUrl(`${MaverickUrls.catalogueSearch(catalogue)}`), payload)
	}
	getSearchCareCatalogue(payload: any, catalogue: CareCatalogues): Promise<ICatalogueSearchResponse[]> {
		return ApiUtils.get(this.getServiceUrl(`${MaverickUrls.catalogueSearch(catalogue)}?${ApiUtils.requestToQueryParams(payload)}`))
	}
	getSearchWorkoutCatalogue(query: string, isFitnessWorkout?: boolean): Promise<ICatalogueSearchResponse[]> {
		return ApiUtils.get(this.getServiceUrl((isFitnessWorkout ? MaverickUrls.fitnessWorkoutSearch : MaverickUrls.meditationWorkoutSearch)(query)))
	}
}
